import { useTranslation } from 'react-i18next';

import { TranslationsKeys } from '../../../locales/translations';
const STATUS_COLOR: Record<string, string> = {
  pending: '#FFE6A1',
  approved: '#CEF0DA',
  rejected: '#F2C0BD',
};

interface RequirementBadgeProps {
  status: string;
}

export default function RequirementBadge({ status }: RequirementBadgeProps) {
  const { t } = useTranslation(TranslationsKeys.GRADUATION_REQUIREMENTS_REVIEW);

  return (
    <span
      className="fs-14 text-dark d-flex align-items-center justify-content-center text-center"
      style={{
        backgroundColor: STATUS_COLOR[status],
        width: 80,
        height: 26,
        borderRadius: 13,
      }}
    >
      {t(`table.status.${status}`)}
    </span>
  );
}
